import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import cookie from 'react-cookie';
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import { checkPropTypes } from "prop-types";

import NfcIcon from "@material-ui/icons/Nfc";
import IconButton from "@material-ui/core/IconButton";

class Sidebar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			self: this, checkedA: true,
			checkedB: true,
			checkedC: true};
	}

	handleChange(event) {
		//alert(event.target.name);
		/*
		if (event.target.name === "a1") {

		}
		else if (event.target.name === "a2") {

		}
		else if (event.target.name === "a3") {

		}
		*/
		this.setState({ ...this.state, [event.target.name]: event.target.checked });
	};

	dologout() {
        //this.state.self.removeCookie();
        this.state.self.removeCookie_device_complete();
        let old_qs = cookie.load("initial_querystring");
        if(old_qs===undefined) {
            window.location = "/";
        } else {
            window.location = "/"+old_qs;
        }
    }
	dologout_goto_audiobook() {
        //this.state.self.removeCookie();
        this.state.self.removeCookie_device_complete();
        let old_qs = cookie.load("initial_querystring");
        window.location = "/HomeAudioBook";
        if(old_qs===undefined) {
            window.location = "/HomeAudioBook";
        } else {
            window.location = "/HomeAudioBook"+old_qs;
        }
    }

    dologin() {
		window.location = "/signin";
    }

	removeCookie() {
		cookie.remove("userid", { path: '/' });
		cookie.remove("userdbid", { path: '/' });
		cookie.remove("orgid", { path: '/' });
		cookie.remove("lc", { path: '/' });
		cookie.remove("lendc", { path: '/' });
		cookie.remove("orgname", { path: '/' });
		cookie.remove("sbc", { path: '/' });
	};

removeCookie_device_complete(userid) {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
    cookie.remove("device_userid", { path: '/' });
    cookie.remove("device_userdbid", { path: '/' });
    cookie.remove("device_orgid", { path: '/' });
    cookie.remove("device_lc", { path: '/' });
    cookie.remove("device_lendc", { path: '/' });
    cookie.remove("device_orgname", { path: '/' });
    cookie.remove("device_sbc", { path: '/' });
};

	getOS() {
		var userAgent = window.navigator.userAgent,
			platform = window.navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'],
			os = null;

		if (macosPlatforms.indexOf(platform) !== -1) {
			os = 'Mac OS';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (!os && /Linux/.test(platform)) {
			os = 'Linux';
		}

		return os;
	}

	render() {

		let struserid = cookie.load("device_userid");
		let struserdbid = cookie.load("device_userdbid");
		let lc = cookie.load("device_lc");
		let lendbookc = cookie.load("device_lendc");
		let orgname = cookie.load("device_orgname");
		let sbc = cookie.load("device_sbc");
		let orgid = cookie.load("device_orgid");
		if (typeof orgid === 'undefined')
			orgid = 0;
		if (typeof orgname === 'undefined')
		    orgname = '';



        let complaint;

        let old_qs = cookie.load("initial_querystring");
        if(old_qs.indexOf("nfc_tag_report=true")>0 || old_qs.indexOf("WEBTEST")>=0) {
            complaint=	<span><br />
                <h4><Link to={
                    {
                        pathname: `/TagComplaint`,
                        state: {
                            title: '불편사항 접수',
                        }
                    }
                }>불편사항 접수</Link></h4></span>;
        }


		if (struserid != null && struserid.length > 0) {

			let os = this.getOS();
			var strSettingLink = "mcbab://setting/" + orgid + "/" + encodeURI(orgname.trim());
			if (os === 'iOS') {
			}
			else {
				strSettingLink = "mcbab://setting/" + orgid + "/" + encodeURI(orgname.trim()) + "/";
            }


            var login_head;

                    //<h5 className="account-title2">이용 가능 콘텐츠: 오디오북 {sbc}권</h5>
                    //<h5 className="account-title2">이용 가능 콘텐츠: 오디오북 미리듣기,NFC태그 전체듣기</h5>
                    //<h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
            if (orgname === "익명사용자" || orgname ==="더책") {
 
                login_head = <div className="sidebar-module sidebar-account">
                    <h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
                </div>;
            } else {
                struserid = "";
                login_head =<div className="sidebar-module sidebar-account">
                    <h3 className="account-title">{struserid}</h3>
                    <h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
                    <h4 className="account-title2-bold">{orgname}</h4>
                </div>;
            }

            var how_to_use;

            if (os === 'iOS') {
                how_to_use = <h4><Link to={
                    {
                        pathname: `/InfoView2`,
                        state: {
                            title: '이용방법',
                            url: 'https://notice.thechaek.com/?page_id=64'
                            //url: 'https://books.changbiedu.com:446/'
                        }
                    }
                }>이용방법</Link></h4>;
            } else {
                how_to_use = <h4><Link to={
                    {
                        pathname: `/InfoView2`,
                        state: {
                            title: '이용방법',
                            url: 'https://notice.thechaek.com/?page_id=64'
                            //url: 'https://books.changbiedu.com:446/'
                        }
                    }
                }>이용방법</Link></h4>;
            }

			return (
                <div className="sidebar">
                    {login_head}

					<div className="sidebar-module3">
						<h4><PersonOutlineOutlinedIcon /> <Link to={"/library"}>내 서재 바로 가기</Link></h4>
						<br/>
					</div>

					<div className="sidebar-module-left">
						<h4><Link to={
							{
								pathname: `/InfoView5`,
								state: {
									title: '공지사항',
                                    url: 'https://notice.thechaek.com/?page_id=93'
								}
							}
						}>공지사항</Link></h4>
                        <br />
                        {how_to_use}
						<br />
						<h4><Link to={
							{
								pathname: `/InfoView6`,
								state: {
									title: '더책 서비스 안내',
                                    url: 'https://notice.thechaek.com/?p=56'
								}
							}
						}>더책 서비스 안내</Link></h4>
						<br />
                        <h4><a href={strSettingLink}>설정</a></h4>
						
					</div>

					<div className="sidebar-module-left">
						<h4><Link to={
							{
								pathname: `/InfoView4`,
								state: {
									title: '이용약관',
                                    url: 'https://notice.thechaek.com/?p=121'
								}
		
					}
						}> 이용약관</Link>
						</h4><br />
						<h4><Link to={
							{
								pathname: `/InfoView3`,
								state: {
									title: '개인정보보호정책',
                                    url: 'https://notice.thechaek.com/?p=110'
								}
							}
						}>개인정보보호정책</Link></h4>

                        {complaint}

					<br />
					<h4>고객센터 <a href={`mailto:cs@changbi.com`} ><font color={'blue'}>cs@changbi.com</font></a></h4>

					</div>

					<div className="sidebar-module-bottom-orig"><center>
                            <Button variant="contained" style={{
				    display: "none",
                                width: "200px",
                                zIndex:10,
                                borderRadius: 5,
                                color: "white",
                                backgroundColor: "#f6ad55",
                                padding: "5px 5px",
                                fontSize: "18px"
                            }} fullWidth="true"  onClick={() => this.dologout_goto_audiobook()}>
                                오디오 라이브러리<br/> 로그인
						</Button></center>
					</div>
				</div>
			);
		}

					//<br />
					//<h4><a href={`mcbab://read_nfctag/for=report&userdbid=${struserdbid}`}
					//>불편 사항 신고 <NfcIcon /></a></h4>
		return (
			<div className="sidebar">
                    <br />

                <div className="sidebar-module-left">
                    <h4><Link to={
                        {
                            pathname: `/InfoView5`,
                            state: {
                                title: '공지사항',
                                url: 'https://notice.thechaek.com/?page_id=93'
                            }
                        }
                    }>공지사항</Link></h4>
                    <br />
                    {how_to_use}
						<br />
						<h4><Link to={
							{
								pathname: `/InfoView6`,
								state: {
									title: '더책 서비스 안내',
                                    url: 'https://notice.thechaek.com/?p=56'
								}
							}
						}>더책 서비스 안내</Link></h4>

						<br />
                        <h4><a href={strSettingLink}>설정</a></h4>
                </div>

                <div className="sidebar-module-left">
                    <h4><Link to={
                        {
                            pathname: `/InfoView4`,
                            state: {
                                title: '이용약관',
                                url: 'https://notice.thechaek.com/?p=121'
                            }

                        }
                    }> 이용약관</Link>
                    </h4><br />
                    <h4><Link to={
                        {
                            pathname: `/InfoView3`,
                            state: {
                                title: '개인정보보호정책',
                                url: 'https://notice.thechaek.com/?p=110'
                            }
                        }
                    }>개인정보보호정책</Link></h4>


                        {complaint}


			<br />
					<h4>고객센터 <a href={`mailto:cs@changbi.com`} ><font color={'blue'}>cs@changbi.com</font></a></h4>
                </div>

					<div className="sidebar-module-bottom-orig"><center>

                            <Button variant="contained" style={{
				    display: "none",
                                width: "200px",
                                zIndex:10,
                                borderRadius: 5,
                                color: "white",
                                backgroundColor: "#f6ad55",
                                padding: "5px 5px",
                                fontSize: "18px"
                            }} fullWidth="true"  onClick={() => this.dologin()}>
                                로그인
						</Button></center>
					</div>
            </div>
		);
	}
}

export default Sidebar;
